export default __webpack_public_path__ + "static/media/baby2 10.17 1.5d29991c.png";